module.exports = __webpack_public_path__ + "media/images/cafod-logo-2b-rgb-4d49820e9507a4075bb7143ccf6c4fe9.svg";